<button mat-icon-button [matMenuTriggerFor]="$any(menu)" (click)="preventSelection($event)"
        aria-label="More menu"
        class="horizontal-menu-element">
    <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #menu="matMenu">
    <button mat-menu-item (click)="emit('details')">
        <mat-icon>unfold_more</mat-icon>
        <span>{{ 'STOCK.MOVEMENTS.OPTIONS.DETAILS' | translate }}</span>
    </button>
    @if (canDownload) {
        <button mat-menu-item (click)="emit('export')">
            <mat-icon>download</mat-icon>
            <span>{{ 'STOCK.MOVEMENTS.OPTIONS.EXPORT' | translate }}</span>
        </button>
    }
    <button mat-menu-item (click)="emit('generate-labels')">
        <mat-icon>document_scanner</mat-icon>
        <span>{{ 'STOCK.MOVEMENTS.OPTIONS.GENERATE_LABELS' | translate }}</span>
    </button>
    <button mat-menu-item (click)="emit('rollback')">
        <mat-icon>undo</mat-icon>
        <span>{{ 'STOCK.MOVEMENTS.OPTIONS.ROLLBACK' | translate }}</span>
    </button>
    @if (showGoodsDelivery) {
        <button mat-menu-item (click)="emit('goods-delivery')">
            <mat-icon>local_shipping</mat-icon>
            <span>{{ 'STOCK.MOVEMENTS.OPTIONS.GOODS_DELIVERY' | translate }}</span>
        </button>
    }
</mat-menu>
